import { hideDrawer, hideHeaderDrawer } from '../../../redux/reducers/appSettingsReducer'
import { useAppDispatch } from '../../../redux/store'
import Button from '../../../shared/UI/Button'
import DrawerFooter from '../../../shared/UI/DrawerFooter'

interface SubmitActionFooterProps {
  canSubmit: boolean
  submit: () => void
  loading?: boolean
}

function SubmitActionFooter({ canSubmit, submit, loading = false }: SubmitActionFooterProps) {
  const dispatch = useAppDispatch()

  return (
    <>
      <DrawerFooter>
        <Button
          color="secondary"
          label="Cancel"
          onClick={() => {
            dispatch(hideHeaderDrawer())
            dispatch(hideDrawer())
          }}
          dataTestId="MyActions-Absence-CancelBtn"
        />
        <Button
          label="Submit"
          type="submit"
          onClick={() => {
            submit()
          }}
          loading={loading}
          dataTestId="MyActions-Absence-SubmitBtn"
          disabled={!canSubmit}
        />
      </DrawerFooter>
    </>
  )
}

export default SubmitActionFooter
